<script setup lang="ts">
import { PropType } from 'vue'
import type { Departure, DepartureSettings, CurrentCulture } from '../../types'
import DepartureRow from './DepartureRow.vue'

defineProps({
  settings: {
    type: Object as PropType<DepartureSettings>,
    required: true,
  },
  departures: {
    type: Object as PropType<Departure[]>,
    required: true,
  },
  currentCulture: {
    type: Object as PropType<CurrentCulture>,
    required: true,
  },
})
</script>
<template>
  <div class="departure-board__list" data-departure-list="">
    <DepartureRow
      v-for="departure in departures"
      :departure="departure"
      :current-culture="currentCulture"
      :journey-time-text="settings.journeyTimeDisplayText"
      :journey-time-text-suffix="settings.journeyTimeDisplayTextSuffix"
    />
  </div>
</template>
